import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: row;

  ${({ $compact }) => $compact &&
    css `
      margin-bottom: var(--space-200);
      line-height: var(--font-line-height-100);
    `}
`;
export const SortableCell = styled.div `
  width: 48px;
`;
